module.exports = __webpack_public_path__ + "static/media/kh.1060af3c.svg";